import { useFeatureFlags } from '#src/hooks/useFeatureFlags.tsx';
import { useIsMobileApp } from '#src/hooks/useIsMobileApp.ts';

export const useHostedIdvIframeMode = () => {
  const {
    flags: { mangopayHostedIdv = false, mangopayHostedIdvIframe = false },
  } = useFeatureFlags();
  const { isMobileApp, isTwa } = useIsMobileApp();

  return mangopayHostedIdv && mangopayHostedIdvIframe && !isMobileApp && !isTwa;
};
